module.exports = __webpack_public_path__ + "img/Weapon_152.ebe8c295.png";